"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Check, Copy } from "lucide-react";
import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-m";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
export type CopyableItemProps = {
  value: string;
  label?: string;
  className?: string;
};
export const CopyableItem = t0 => {
  const $ = _c(36);
  const {
    value,
    label,
    className
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== value) {
    t1 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (t2) {
        const _error = t2;
      }
    };
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("inline-flex items-center gap-1.5 pl-1.5 py-0.5 bg-background rounded border relative overflow-hidden", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== copied) {
    t3 = copied && <motion.span animate={{
      opacity: 1,
      scale: 1
    }} className="absolute inset-0 bg-green-500/10" exit={{
      opacity: 0
    }} initial={{
      opacity: 0,
      scale: 0.8
    }} key="success-bg" transition={{
      duration: 0.3
    }} />;
    $[4] = copied;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <AnimatePresence mode="wait">{t3}</AnimatePresence>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== value) {
    t5 = <code className="font-mono text-xs relative z-10 whitespace-pre-wrap break-all line-clamp-1 select-none pointer-events-none">{value}</code>;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = copied ? copied : undefined;
  const t7 = `Copy ${label || "code"}`;
  const t8 = copied && "hover:bg-transparent";
  let t9;
  if ($[10] !== t8) {
    t9 = cn("relative z-10 flex items-center justify-center rounded p-0.5 hover:bg-accent/50 transition-colors", t8);
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      scale: 0.9
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== copied) {
    t11 = <AnimatePresence mode="wait">{copied ? <motion.div animate={{
        rotate: 0,
        scale: 1
      }} exit={{
        rotate: 90,
        scale: 0.3
      }} initial={{
        rotate: -90,
        scale: 0.3
      }} key="check" transition={{
        damping: 20,
        stiffness: 300,
        type: "spring"
      }}><Check className="size-4 text-success dark:success" /></motion.div> : <motion.div animate={{
        rotate: 0,
        scale: 1
      }} exit={{
        rotate: -90,
        scale: 0.3
      }} initial={{
        rotate: 90,
        scale: 0.3
      }} key="copy" transition={{
        damping: 20,
        stiffness: 300,
        type: "spring"
      }}><Copy className="size-4 text-muted-foreground hover:text-foreground transition-colors" /></motion.div>}</AnimatePresence>;
    $[13] = copied;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== handleCopy || $[16] !== t11 || $[17] !== t7 || $[18] !== t9) {
    t12 = <TooltipTrigger asChild={true}><motion.button aria-label={t7} className={t9} onClick={handleCopy} type="button" whileTap={t10}>{t11}</motion.button></TooltipTrigger>;
    $[15] = handleCopy;
    $[16] = t11;
    $[17] = t7;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  let t14;
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      opacity: 1,
      y: 0
    };
    t14 = {
      opacity: 0,
      y: -2
    };
    t15 = {
      opacity: 0,
      y: 2
    };
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t13 = $[20];
    t14 = $[21];
    t15 = $[22];
  }
  const t16 = copied ? "copied" : "copy";
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      duration: 0.15
    };
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const t18 = copied ? "Copied!" : "Copy";
  let t19;
  if ($[24] !== t16 || $[25] !== t18) {
    t19 = <TooltipContent side="top" sideOffset={4}><motion.span animate={t13} exit={t14} initial={t15} key={t16} transition={t17}>{t18}</motion.span></TooltipContent>;
    $[24] = t16;
    $[25] = t18;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t12 || $[28] !== t19 || $[29] !== t6) {
    t20 = <Tooltip open={t6}>{t12}{t19}</Tooltip>;
    $[27] = t12;
    $[28] = t19;
    $[29] = t6;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t2 || $[32] !== t20 || $[33] !== t4 || $[34] !== t5) {
    t21 = <div className={t2}>{t4}{t5}{t20}</div>;
    $[31] = t2;
    $[32] = t20;
    $[33] = t4;
    $[34] = t5;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  return t21;
};